import { Injectable, Inject, Optional } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BOT_SERVICE_TOKEN } from '../render-store/unified-survey.store';

@Injectable({
  providedIn: 'root',
})
export class AfmOptionResolverService {
  constructor(
    @Optional() @Inject(BOT_SERVICE_TOKEN) private botService: any,
  ) {}

  resolveOptions(
    options: any[] | null |undefined,
    currentPageValue: any,
  ): Observable<any[]> {
    const validOptions = options ?? [];

    const afmOptions = validOptions.filter(
      o => o?.is_afm_trigger === true,
    );

    if (
      afmOptions.length === 0 ||
      !this.botService ||
      typeof this.botService.fetchAfmOptions !== 'function'
    ) {
      return of(validOptions);
    }

    return forkJoin(
      afmOptions.map(opt =>
        this.botService.fetchAfmOptions(
          opt.simple_props,
          currentPageValue,
        ),
      ),
    ).pipe(
      map(results => results.flat()),
    );
  }
}